var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "#000",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.16 9.742h-.64V6.194c0-1.96-1.576-3.549-3.52-3.549S8.48 4.234 8.48 6.194v3.548h-.64V6.194C7.84 3.878 9.702 2 12 2s4.16 1.878 4.16 4.194v3.548zm2.56.645H5.28c-.707 0-1.28.578-1.28 1.29v9.033c0 .712.573 1.29 1.28 1.29h13.44c.707 0 1.28-.578 1.28-1.29v-9.033c0-.712-.573-1.29-1.28-1.29zm-6.4 6.745v1.965a.321.321 0 0 1-.32.322.321.321 0 0 1-.32-.322v-1.965a1.933 1.933 0 0 1-1.593-2.07A1.926 1.926 0 0 1 12 13.288c.998 0 1.83.771 1.913 1.774a1.933 1.933 0 0 1-1.593 2.07z",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0a709af596a8cba9e2c74f1bee4fd748.svg";
export { ForwardRef as ReactComponent };